import App from './App.svelte';
import AbstractID from './AbstractID';
import { loadConfiguration } from './AppConfiguration';

// This template's svelte-spa-router uses the History API (real path URLs, no
// hash). The public status page (root) is anonymous; only admin routes
// (/Admin...) trigger an AbstractID login redirect.
const initialPath = window.location.pathname || '/';
const isAdminRoute = initialPath.startsWith('/Admin');

AbstractID.initialize({ redirectIfUnauthenticated: isAdminRoute });
loadConfiguration();

const app = new App({
  target: document.getElementById('app')
});

export default app;
